import { z } from 'zod';
import { transactionRequestSchema } from '../../transaction/api/transaction-types';
import { assignmentRequestSchema } from '../../bucket/form/use-save-assignment-form';
// Account State
export var AccountState;
(function (AccountState) {
    AccountState["ACTIVE"] = "ACTIVE";
    AccountState["ARCHIVED"] = "ARCHIVED";
})(AccountState || (AccountState = {}));
// Account Type
export var AccountType;
(function (AccountType) {
    AccountType["CASH"] = "CASH";
    AccountType["CHECKING"] = "CHECKING";
    AccountType["SAVINGS"] = "SAVINGS";
    AccountType["CREDIT_CARD"] = "CREDIT_CARD";
    AccountType["OFF_BUDGET_ASSET"] = "OFF_BUDGET_ASSET";
    AccountType["OFF_BUDGET_LIABILITY"] = "OFF_BUDGET_LIABILITY";
})(AccountType || (AccountType = {}));
// Account Request
export const accountRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    name: z.string(),
    notes: z.string().optional(),
    offBudgetGroup: z.string().optional(),
    type: z.nativeEnum(AccountType),
    state: z.nativeEnum(AccountState),
    position: z.number(),
    assignments: assignmentRequestSchema.array(),
    externalAccountId: z.string().uuid().optional(),
});
// Account Request Add
export const accountRequestAddSchema = accountRequestSchema.extend({
    transactions: transactionRequestSchema.array(),
});
// Account Sort
export const accountRequestSortSchema = z.object({
    budgetId: z.string().uuid(),
    ids: z.array(z.string().uuid()),
});
// Account Delete
export const accountDeleteSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
});
